var infraestructura = angular.module('infraestructuras');

infraestructura.controller('tunelADIFController', ['$rootScope', '$scope', '$location', 'infraestructurasService', '$routeParams', 'authenticationInfo', 'authenticationService', 'infraestructurasAdminService', 'inspeccionesService'
    , function ($rootScope, $scope, $location, infraestructurasService, $routeParams, authenticationInfo, authenticationService, infraestructurasAdminService, inspeccionesService) {

        $scope.authentication = authenticationInfo;
        $scope.pestanyavisible = 'general';
        $scope.pestanyamenuinspeccion = 'general';
        //$scope.pestanyamenusuperior = 'informacion';
        $scope.pestanyamenusuperior = 'inspeccion';
        //$rootScope.InfraestructuraId = $routeParams.id;
        $scope.longitud = 1000;

        $rootScope.TunelADIFId = $routeParams.id;
        $scope.CategoriaId = $rootScope.categoria;


        if ($rootScope.parteUrl == true) {
            $scope.OpcionSeleccionada = "app/Partes/partes.html";
            $scope.OpcionSeleccionadaClass = 'parte';
            $scope.pestanyaparte = "tab-parte active"
            $scope.pestanyanube = "tab-nube"
            $rootScope.parteUrl = false;
            $rootScope.inspeccionUrl = false;
        }
        else {
            if ($rootScope.inspeccionUrl == true) {
                $scope.pestanyamenusuperior = 'inspeccion';
            }
            $scope.OpcionSeleccionada = "app/TV/TV.html";
            $scope.OpcionSeleccionadaClass = 'tv';
            $scope.pestanyaparte = "tab-parte"
            $scope.pestanyanube = "tab-nube active"
            $rootScope.inspeccionUrl = false;
            $rootScope.parteUrl = false;
        }

        $scope.idObra = $routeParams.id;

        $scope.eliminarInspeccion = function (idInspeccion) {
            check = confirm("¿Seguro que deseas eliminar esta inspección?")

            if (check) {
                inspeccionesService.eliminarInspeccion(idInspeccion)
                    .then(function (response) {
                        infraestructurasService.getInspeccionesTunelADIF($scope.tunelADIF.Id)
                            .then(function (response) {
                                $scope.inspecciones = response.data || [];
                            });
                    });
            }
        }

        infraestructurasAdminService.getEntornos()
            .then(function (response) {
                var data = response.data;
                $scope.entornos = data;
            });



        infraestructurasAdminService.getInspectores()
            .then(function (response) {
                var data = response.data;
                $scope.inspectores = data;
            });


        infraestructurasAdminService.getPropietarios()
            .then(function (response) {
                var data = response.data;
                $scope.propietarios = data;
            });

        infraestructurasAdminService.getMunicipios()
            .then(function (response) {
                var data = response.data;
                $scope.municipios = data;
            });


        $scope.validarSeleccion = function () {
            if (!$scope.informeSeleccionado) {
                // Si no se selecciona un informe, muestra una alerta
                alert("Por favor, seleccione un informe antes de continuar.");
                return;
            }

            // Si se seleccionó un informe, procede con la generación
            $scope.imprimirInforme($scope.ultimainspeccion);
        };


        // Variable que representa el valor del índice
        const indiceValor = 2; // Cambia este valor dinámicamente (1, 2 o 3)

        var tunelADIFId = parseInt($routeParams.id, 10);

        if (isNaN(tunelADIFId)) {
            console.error('El identificador de TunelADIF no es válido');
            return;
        }

        $rootScope.TunelADIFId = tunelADIFId;
        

        infraestructurasService.getTunelADIF($rootScope.TunelADIFId)
            .then(function (response) {

                $scope.tunelADIF = response.data;

                // Solo si el HTML antiguo utiliza la variable "tunel".
                $scope.tunel = $scope.tunelADIF;

                return infraestructurasService
                    .getInspeccionesTunelADIF(tunelADIFId);
            })
            .then(function (response) {

                $scope.inspecciones = response.data || [];

                if ($scope.inspecciones.length === 0) {
                    $scope.ultimainspeccion = null;
                    console.warn('El túnel ADIF no tiene inspecciones');
                    return;
                }

                var inspeccion = $scope.inspecciones[0];

                $scope.ultimainspeccion = {
                    Id: inspeccion.Id,
                    FechaFin: inspeccion.FechaFin,
                    FechaInicio: inspeccion.FechaInicio,

                    InspectorDescripcion: inspeccion.Inspector
                        ? inspeccion.Inspector.Descripcion
                        : '',

                    InspectorId: inspeccion.Inspector
                        ? inspeccion.Inspector.Id
                        : null,

                    PropietarioDescripcion: inspeccion.Propietario
                        ? inspeccion.Propietario.Descripcion
                        : '',

                    PropietarioId: inspeccion.Propietario
                        ? inspeccion.Propietario.Id
                        : null
                };

                if (typeof ChartDataLabels !== 'undefined') {
                    Chart.register(ChartDataLabels);
                }
            })
            .catch(function (error) {
                console.error(
                    'Error al cargar el túnel ADIF o sus inspecciones:',
                    error
                );
            });

        $scope.getColor = function (gravedad) {
            switch (gravedad) {
                case 1:
                    return "green";
                case 2:
                    return "yellow";
                case 3:
                    return "darkorange";
                case 4:
                    return "red";
                default:
                    return "#E0E0E0";
            }
        };

        $scope.getWidth = function (seccion, cantidad) {
            var total = seccion.TotalDanos || 1; // Evitar división por 0
            return (cantidad / total) * 120; // Ajusta al ancho de la sección
        };

        $scope.getOffset = function (seccion, gravedad) {
            var offset = 0;
            for (var g in seccion.DañosPorGravedad) {
                if (g == gravedad) break;
                offset += $scope.getWidth(seccion, seccion.DañosPorGravedad[g]);
            }
            return offset;
        };

        infraestructurasService.getTiposTunel()
            .then(function (response) {
                var data = response.data;
                $scope.tiposTunel = data;
            });

        infraestructurasService.getTiposPresa()
            .then(function (response) {
                var data = response.data;
                $scope.tipoPresa = data;
            });

        infraestructurasService.getformaPlanta()
            .then(function (response) {
                var data = response.data;
                $scope.formaPlanta = data;
            });

        infraestructurasService.getObstaculos()
            .then(function (response) {
                var data = response.data;
                $scope.obstaculos = data;
            });

        infraestructurasService.getNumDireccionesTunel()
            .then(function (response) {
                var data = response.data;
                $scope.numDireccionesTunel = data;
            });

        infraestructurasService.getMaterialesTunel()
            .then(function (response) {
                var data = response.data;
                $scope.materiales = data;
            });

        infraestructurasService.getMaterialesPresa()
            .then(function (response) {
                var data = response.data;
                $scope.materialesPresa = data;
            });

        infraestructurasService.getCategoriaPresa()
            .then(function (response) {
                var data = response.data;
                $scope.categoriaPresa = data;
            });

        infraestructurasService.getUsosPresa()
            .then(function (response) {
                var data = response.data;
                $scope.usosPresa = data;
            });

        infraestructurasService.getTipoVia()
            .then(function (response) {
                var data = response.data;
                $scope.tiposVia = data;
            });

        infraestructurasService.getCirculacionPermitida()
            .then(function (response) {
                var data = response.data;
                $scope.circulacionesPermitida = data;
            });

        infraestructurasService.getCategoria($rootScope.categoria)
            .then(function (response) {
                var data = response.data;
                $scope.categoria = data;
            });


        $scope.verCategorias = function () {
            $rootScope.inspeccionUrl = false;
            $rootScope.parteUrl = false;
            $location.path('/categorias');
        };



        $scope.guardarInventario = function () {

            if ($scope.esTunel) {

                if (
                    !$scope.infraestructura.CodIdentificador ||
                    !$scope.infraestructura.Propietario ||
                    !$scope.infraestructura.Propietario.Id ||
                    !$scope.infraestructura.Entorno ||
                    !$scope.infraestructura.Entorno.Id ||
                    !($scope.infraestructura.Municipio && $scope.infraestructura.Municipio.Id)
                ) {
                    alert("Debes rellenar todos los campos obligatorios antes de guardar.");
                }


                $scope.tunel.InfraestructuraId = $routeParams.id;
                $scope.tunel.AñoConstruccion = $scope.tunel.AnioConstruccion;
                $scope.tunel.MaterialHastialDcholId = $scope.tunel.MaterialHastialDchoId;
                if ($scope.tunel.Id != undefined) {
                    var formDataTunel = new FormData();
                    formDataTunel.append("tunel", JSON.stringify($scope.tunel));

                    infraestructurasService.guardarInventarioTunel($scope.tunel.Id, formDataTunel, $scope.infraestructura.CodIdentificador, $scope.infraestructura.Propietario.Id, $scope.infraestructura.Entorno.Id, $scope.infraestructura.Municipio.Id)
                        .then(function (response) {
                            var data = response.data;
                            $scope.tunel.Id = data;
                            alert("Datos guardados correctamente");
                        });
                } else {
                    $scope.tunel.Id = -1;
                    infraestructurasService.guardarInventario($scope.tunel)
                        .then(function (response) {
                            var data = response.data;
                            $scope.tunel.Id = data;
                            alert("Datos guardados correctamente");
                        });
                }
            } else if ($scope.esPresa) {

                if (
                    !$scope.infraestructura.CodIdentificador ||
                    !($scope.infraestructura.Municipio && $scope.infraestructura.Municipio.Id)
                ) {
                    alert("Debes rellenar todos los campos obligatorios antes de guardar.");
                }



                if ($scope.presa.Id != undefined) {
                    var formDataPresa = new FormData();
                    formDataPresa.append("presa", JSON.stringify($scope.presa));
                    infraestructurasService.guardarInventarioPresa($scope.presa.Id, formDataPresa, $scope.infraestructura.Nombre, $scope.infraestructura.CodIdentificador, $scope.infraestructura.Municipio.Id)
                        .then(function (response) {
                            var data = response.data;
                            $scope.presa.Id = data;
                            alert("Datos guardados correctamente");
                        });
                } else {
                    $scope.presa.Id = -1;
                    infraestructurasService.guardarInventario($scope.presa)
                        .then(function (response) {
                            var data = response.data;
                            $scope.presa.Id = data;
                            alert("Datos guardados correctamente");
                        });
                }
            }
        };


        $scope.guardarInspeccion = function () {
            infraestructurasService.guardarInspeccion($scope.inspeccion)
                .then(function (response) {
                    var data = response.data;
                    $scope.tunel.Id = data;
                    alert("Datos guardados correctamente");
                });
        };

        $scope.volver = function () {
            $location.path('/tunelesADIF');
        };

        $scope.getModelo = function () {
            //$location.path("/modelo/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/VisorModelos/visorModelos.html";
            $scope.OpcionSeleccionadaClass = 'modelos';
        }


        $scope.getSensores = function () {
            //$location.path("/modelo/" + $routeParams.id);
            if ($scope.infraestructura && $scope.infraestructura.CategoriaId === 3) {
                $scope.OpcionSeleccionada = "app/Sensores/mediciones.html";
            }
            else {
                $scope.OpcionSeleccionada = "app/Sensores/Sensores.html";
            }
            $scope.OpcionSeleccionadaClass = 'sensores';
        }

        $scope.nuevaInspeccion = function () {
            $location.url('/inspecciones/0');
        }

        $scope.getNubeDePuntos = function () {
            //$location.path("/TV/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/TV/TV.html";
            $scope.OpcionSeleccionadaClass = 'tv';
        }

        $scope.getGestionDocumental = function () {
            //$location.path("/TV/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/GestionDocumental/gestiondocumental.html";
            $scope.OpcionSeleccionadaClass = 'docs';
        }

        $scope.getRealidadVirtual = function () {
            //$location.path("/TV/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/TourVirtual/tourvirtual.html";
            $scope.OpcionSeleccionadaClass = 'rv';
        }


        $scope.getPartes = function () {
            $scope.OpcionSeleccionada = "app/Partes/partes.html";
            $scope.OpcionSeleccionadaClass = 'parte';
        }

        $scope.getGIS = function () {
            $scope.OpcionSeleccionada = "app/GIS/gis.html";
            $scope.OpcionSeleccionadaClass = 'gis';
        }




        $scope.logout = function () {
            //$rootScope.bodylayout = "login";
            return authenticationService.logout();
        }

        $scope.TipologiaCargar = function () {
            $scope.pestanyavisible = 'tipologia';
        }

        $scope.DimensionesCargar = function () {
            $scope.pestanyavisible = 'dimensiones';
        }

        $scope.MaterialesCargar = function () {
            $scope.pestanyavisible = 'materiales';
        }

        $scope.ImportanciaCargar = function () {
            $scope.pestanyavisible = 'importancia';
        }

        $scope.ElementosInspeccionadosCargar = function () {
            $scope.pestanyamenuinspeccion = 'elementosinspeccionados';
        }

        $scope.ElementosEvaluadosCargar = function () {
            $scope.pestanyamenuinspeccion = 'elementosevaluados';
        }

        $scope.InventarioCargar = function () {
            $scope.pestanyamenusuperior = 'inventario';
        }


        $scope.AuscultacionesCargar = function() {
            $scope.pestanyamenusuperior = 'auscultaciones';
        }


        $scope.InspeccionCargar = function () {
            $scope.pestanyamenusuperior = 'inspeccion';
        }

        $scope.ConservacionCargar = function () {
            $scope.pestanyamenusuperior = 'conservacion';
        }

        $scope.InformacionCargar = function () {
            //$scope.calcularGrafico();
            $scope.pestanyamenusuperior = 'informacion';
        }

        $scope.VisualizacionCargar = function () {
            $scope.pestanyamenusuperior = 'visualizacion';
        }

        // Funciones del tooltip
        $scope.showTooltip = function (event, seccion) {
            var tooltip = document.getElementById("tooltip");
            //var contenido = '<b>Sección:</b> ${seccion.Seccion}m<br>'
            var contenido = '';
            if (seccion.Gravedades.length > 0) {
                contenido += "<b>Daños:</b><br>";
                seccion.Gravedades.forEach(function (gravedad) {
                    var color = ""; // Variable para el color del texto
                    // Definir el color según el nivel de gravedad
                    if (gravedad.Gravedad === "Leve") {
                        color = "green";
                    } else if (gravedad.Gravedad === "Moderado") {
                        color = "#f7d547"; // Amarillo
                    } else if (gravedad.Gravedad === "Severo") {
                        color = "darkorange"; // Naranja
                    } else if (gravedad.Gravedad === "Critico") {
                        color = "red";
                    }
                    // Agregar la información con el color correspondiente
                    contenido += '<span style="color:' + color + ';">' + gravedad.Gravedad + ": " + gravedad.Conteo + "</span><br>";
                });
            } else {
                contenido += "Sin daños";
            }
            tooltip.innerHTML = contenido;
            tooltip.style.display = "block";
        };
        $scope.moveTooltip = function (event) {
            var tooltip = document.getElementById("tooltip");
            tooltip.style.left = (event.pageX + 10) + "px";
            tooltip.style.top = (event.pageY + 10) + "px";
        };
        $scope.hideTooltip = function () {
            var tooltip = document.getElementById("tooltip");
            tooltip.style.display = "none";
        };


    }]);